import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlogpostService } from '../blogpost.service';
import { Blogpost } from '../blogpost';

@Component({
  selector: 'app-blogpost-featured',
  templateUrl: './blogpost-featured.component.html',
  styleUrls: ['./blogpost-featured.component.css']
})
export class BlogpostFeaturedComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();

  blogs: Blogpost;
  error: {};

  constructor(
    private blogpostService: BlogpostService
  ) { }

  ngOnInit() {
    this.blogpostService.getFeaturedBlogs().pipe(takeUntil(this.destroy$)).subscribe(
      (data: Blogpost) => this.blogs = data,
      error => this.error = error
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
